import { render, staticRenderFns } from "./UserProyecto.vue?vue&type=template&id=fc161b1a&scoped=true&"
import script from "./UserProyecto.vue?vue&type=script&lang=js&"
export * from "./UserProyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc161b1a",
  null
  
)

export default component.exports